import { AppState } from 'services/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
// @ts-ignore
import { selectPeopleKeyedByUserId } from 'services/people/selectors';
import get from 'lodash.get';
import { SpraySubmissionsState } from './types';

const selectSpraySubmissions = (state: AppState): SpraySubmissionsState =>
    state.spraySubmissions;

const selectSpraySubmissionsArray = createDeepEqualSelector(
    selectSpraySubmissions,
    (submissions) => Object.values(submissions)
);

const selectFormattedSpraySubmissions = createDeepEqualSelector(
    selectSpraySubmissionsArray,
    selectPeopleKeyedByUserId,
    (submissions, peopleKeyedByUserId) =>
        submissions.map((submission) => {
            const createdBy = get(
                peopleKeyedByUserId,
                [submission.createdByUserId, 'fullName'],
                ''
            );

            return {
                ...submission,
                createdBy
            };
        })
);

export {
    selectSpraySubmissions,
    selectSpraySubmissionsArray,
    selectFormattedSpraySubmissions
};
